module.exports = require("@wallaby-ui/merie/src/js/config/app_config");